import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaDireccion } from '../_direccion.js';

/**
 * La bandeja de validación de compras. Fase 8, tarea 24.
 *
 * EN `_direccion` PORQUE VALIDAR ES SOLO DEL ADMINISTRADOR: `compra.validar` en la matriz, y la función la
 * rechaza con `42501` para cualquier otro rol. Registrar va en `/compras`, en `_egresos`, que admite a
 * los cuatro. Son dos pantallas porque son dos públicos.
 */
export const rutaValidacionCompras = createRoute({
  getParentRoute: () => rutaDireccion,
  path: '/compras/validacion',
  component: lazyRouteComponent(
    () => import('./validacion-compras-pantalla.js'),
    'RutaValidacionCompras',
  ),
});
